import link from "@/scripts/host.js";
import handleError from "@/scripts/handleError.js";

export default {
  name: "Login",
  props: ["close"],
  data() {
    return {
      login: "",
      password: "",
      remember: false,
      invalid: false,
    };
  },
  methods: {
    closeModal() {
      this.$store.dispatch("toggleLoginModal");
    },
    forgotPass() {
      this.$store.dispatch("setModalType", "forgot");
    },
    register() {
      this.$store.dispatch("setModalType", "register");
    },
    logIn() {
      this.axios({
        method: "post",
        url: `${link.hostLink}Account/Login`,
        data: { login: this.login, password: this.password, rememberMe: this.remember }
      })
        .then(response => {
          if (this.remember) {
            localStorage.setItem("user", JSON.stringify(response.data.data));
          } else {
            sessionStorage.setItem("user", JSON.stringify(response.data.data));
          }
          this.$store.dispatch("toggleLoginModal");
          this.$store.dispatch('setLogInFlag', true);
        })
        .catch((error) => {
          if(error.response.data.data && error.response.data.data.token){
            localStorage.setItem("token", JSON.stringify(error.response.data.data.token));
          }
          error.response.status == "400"
            ? (this.invalid = true)
            : (this.invalid = false);
          handleError(error.response);
        });
    }
  },
  mounted() {}
};
